import { observable, action, computed, makeObservable } from 'mobx'

import { ganApi } from '@client/api/'

export class SaveAsTemplateDialogModel {
  @observable show = false
  @observable name = ''
  @observable saved = false
  @observable error = false
  @observable saving = false

  constructor() {
    makeObservable(this)
  }

  @computed get canBeSaved() {
    return this.name.trim().length > 0
  }

  @action showDialog = () => {
    this.show = true
    this.name = ''
    this.saved = false
    this.error = false
    this.saving = false
  }

  @action setName = (name) => {
    this.name = name
  }

  @action save = async (item) => {
    this.saving = true
    const serializedMail = item.serialize()
    serializedMail.subject = this.name
    let result
    try {
      result = await ganApi.createTemplate(serializedMail)
    } catch (e) {
      console.error(e)
    }
    if (result && result.id) {
      this.saved = true
    } else {
      this.error = true
    }
    this.saving = false
  }

  @action hideDialog = () => {
    this.show = false
    this.name = ''
    this.saved = false
    this.error = false
    this.saving = false
  }
}

export const saveAsTemplateDialogModel = new SaveAsTemplateDialogModel()
export const showDialog = saveAsTemplateDialogModel.showDialog
export const hideDialog = saveAsTemplateDialogModel.hideDialog
